/*
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

import { NodeRecordTypeMap } from '../../../backendModels/records.model';
import { InputState } from '../../../backendModels/general.model';
import { MultiSelectFieldValueTyped } from '../../generic';
import { TextFieldValue } from '../../../backendModels/generic-element.model';

export enum MedicalConditionPediatricsKeys {
  fieberkrampf = 'FIEBERKRAMPF',
  pseudokrupp = 'PSEUDOKROUPP',
  sids = 'SIDS',
}

export const MEDICAL_CONDITION_PEDIATRICS_ELEMENT_KEY = 'erkrankungenPaed';

export type MedicalConditionPediatricsRecord = NodeRecordTypeMap['generic'] &
  (
    | {
        readonly elementKey: typeof MEDICAL_CONDITION_PEDIATRICS_ELEMENT_KEY;
        readonly inputState: InputState.ENTERED;
        readonly values: {
          erkrankungenPaed?: MultiSelectFieldValueTyped<MedicalConditionPediatricsKeys>;
          erkrankungenPaedSonstige?: TextFieldValue;
        };
      }
    | {
        readonly inputState: InputState.UNKNOWN;
        readonly values: null;
      }
    | {
        readonly inputState: InputState.NORMAL;
        readonly values: null;
      }
  );

const pediatricsLabels: Record<MedicalConditionPediatricsKeys, string> = {
  [MedicalConditionPediatricsKeys.fieberkrampf]: 'Fieberkrampf',
  [MedicalConditionPediatricsKeys.pseudokrupp]: 'Pseudokrupp',
  [MedicalConditionPediatricsKeys.sids]: 'SIDS / Near-SIDS',
};

export function getPediatricsTupel(key: MedicalConditionPediatricsKeys): [MedicalConditionPediatricsKeys, string] {
  return [key, pediatricsLabels[key]];
}

export function getPediatricsTupelsFor(
  keys: MedicalConditionPediatricsKeys[]
): [MedicalConditionPediatricsKeys, string][] {
  return keys.map((k) => {
    return getPediatricsTupel(k);
  });
}
